module.exports = __webpack_public_path__ + "img/planta_13.d033f95f.png";